/*eslint-disable */
import {
  mapGetters
} from 'vuex'; 
const $ = window.jQuery = require('jquery');  
import toast from '../../../services/toast';
export default {
  name: 'account-su-updates-update',
  components: {},
  props: [],
  data () {
    return {
      submitted:false,
      content:'',
      is_visible:Boolean,
      updatesList:'',
    }
  },
  computed: {
    ...mapGetters([
      'getSuAcUpdatesListByIdGetters'
    ]),
    getUpdateListDetailsFun(){
      this.updatesList = this.$store.getters.getSuAcUpdatesListByIdGetters.data
    },
    setInitialState(){
      if(this.updatesList != undefined){
        this.content = this.updatesList.content
        this.is_visible = this.updatesList.is_visible
      }
    }
  },
  mounted () {
    this.getUpdateListDetailsFun
    this.setInitialState
  },
  methods: {
    validateBeforeSubmit(e) {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
            let data = {
              content:this.content,
              is_visible:this.is_visible
            }
            this.$store.dispatch('updateSuAcUpdatesListFun', {
              data:{
                id:this.$route.params.updatesId, 
                data:data
              }
            }).then((res) => {
                  toast.success(res.data.msg);            
                  this.$router.push('/su/account/updates/list/');
              }).catch((err) => {
                toast.error(err.data.user_msg);  
              })
            return;
        }
      });
    }
  },
  watch:{
    getUpdateListDetailsFun(){
      return this.$store.getters.getSuAcUpdatesListByIdGetters
    },
    setInitialState(){
      if(this.updatesList != undefined){
        this.content = this.updatesList.content
        this.is_visible = this.updatesList.is_visible
      }
    }
  }
}


